// Pull the Instance Reference search value out of the filter store shape.
// Instance Reference is stored on the nested instance filter as `name`.
const getInstanceReferenceValue = input => {
  const value = input?._edition?._instance?.name?.value;
  return typeof value === "string" && value.trim() !== "" ? value.trim() : null;
};

// Force the Instance Reference filter to an exact match. The reference field is
// a plain text input, so it defaults to a partial ("like") match, which would
// wrongly pull in unrelated references that merely contain the typed text. A
// reference identifies a single instance, so it must be matched exactly.
const withExactInstanceReference = input => {
  const reference = input?._edition?._instance?.name;

  if (!reference || typeof reference.value !== "string") {
    return input;
  }

  return {
    ...input,
    _edition: {
      ...input._edition,
      _instance: {
        ...input._edition._instance,
        name: { ...reference, operator: "eq" },
      },
    },
  };
};

// Decide where a submitted artwork search should land. When an Instance
// Reference is supplied and it resolves to exactly one artwork we jump straight
// to that artwork's detail page. Every other search (no instance reference, no
// match, or more than one match) falls back to the results list so the user can
// pick from the matches.
const getArtworkSearchDestination = ({
  input,
  edges = [],
  count,
  listSearch = "",
} = {}) => {
  const instanceReference = getInstanceReferenceValue(input);
  const matchedArtworkId =
    instanceReference && count === 1 ? edges?.[0]?.id : null;

  if (matchedArtworkId != null) {
    return `/artworks/${matchedArtworkId}/details?${listSearch || "status=all"}`;
  }

  return `/artworks?${listSearch}`;
};

export {
  getInstanceReferenceValue,
  getArtworkSearchDestination,
  withExactInstanceReference,
};
